module.exports = __webpack_public_path__ + "img/app-store.b5a04955.svg";